import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

export function useAuth() {
  const {
    isAuthenticated,
    isLoading,
    user,
    loginWithRedirect,
    logout: auth0Logout,
    getAccessTokenSilently,
  } = useAuth0();

  const login = useCallback(() => {
    loginWithRedirect();
  }, [loginWithRedirect]);

  const signup = useCallback(() => {
    loginWithRedirect({
      authorizationParams: { screen_hint: 'signup' },
    });
  }, [loginWithRedirect]);

  const logout = useCallback(() => {
    // A deliberate sign-out should not trigger the reconnect prompt next visit.
    localStorage.removeItem('rikoro:hadSession');
    localStorage.removeItem('rikoro:reconnectDismissedAt');
    auth0Logout({
      logoutParams: { returnTo: window.location.origin },
    });
  }, [auth0Logout]);

  return { isAuthenticated, isLoading, user, login, signup, logout, getAccessTokenSilently };
}
